<template>
  <div class="add-hotspot-box">
    <!-- 热点 -->
    <div class="hotspot-inp-box" v-if="toolAct == 1">
      <div class="hotspot-view">
        类型:
        <select name="" id="" v-model="selectValue" @change="changeType">
          <option value="2">场景放大</option>
          <option value="3">场景切换</option>
          <option value="4">普通标记</option>
          <option value="5">弹层内容</option>
          <!--          <option value="5">文本弹层</option>-->
          <!-- <option value="0">视频</option> -->
        </select>
      </div>
      <div class="hotspot-view">
        标题
        <input type="text" v-model="title"/>
      </div>
      <!-- 场景切换 -->
      <div class="hotspot-view">
        图标
        <div class="hotspot-icon">
          <div class="hotspot-icon-act" @click="ShowIcon">
            <img :src="actions" alt="">
          </div>
          <div class="iconlist" v-show="isShowIcon">
            <div v-for="(icon, index) in iconList" :class="actions == icon ? 'icon-box act' : 'icon-box'" :key="index"
                 @click="selectIcon(icon.filePath)">
              <img :src="icon.filePath" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="hotspot-view">
        图标大小(缩放比例)
        <el-slider v-model="scale" style="width: 100%;" @change="scaleChange"></el-slider>
        <div class="img-size" id="imgHtml"></div>
      </div>
      <!-- 文本标记 -->
      <!-- <div class="hotspot-view" v-if="selectValue == 2">
        图标
        <div class="hotspot-icon">
          <div class="hotspot-icon-act" @click="ShowIcon">
            <img :src="actions" alt="">
          </div>
        </div>
      </div> -->
      <div class="hotspot-view" v-if="selectValue == 3">
        场景切换
        <div class="select">
          <div :class="selectSceneId == scene.index ? 'select-box selAct' : 'select-box'"
               v-for="(scene, index) in sceneList" :key="index" @click="selectScene(scene.index)">
            <img :src="scene.thumburl">
            <span
                style="width: 90px; margin-left: 5px; height: 30px;text-overflow: ellipsis; overflow: hidden; white-space: nowrap; ">{{
                scene.remark
              }}</span>
          </div>
        </div>

        <!-- <select name="" id="" v-model="selectSceneId" @change="changeScene">
          <option v-for="scene in sceneList" :key="scene.thumburl" :value="scene.index"
            :disabled="currentSceneId == scene.index">
            {{ scene.title }}
          </option>
        </select> -->
      </div>
      <div class="hotspot-view" v-if="selectValue == 5">
       热点富文本
        <button class="hotspot-but-s" @click="changeEditor">
          {{!iseditorShow? '打开富文本弹窗' : '关闭富文本弹窗' }}
        </button>
      </div>
      <div>
        <button class="hotspot-but-s" @click="clickConfirm">完成设置</button>
        <button class="hotspot-but-c" @click="clickCancel">取消设置</button>
      </div>
    </div>
    <!-- 视频 -->
    <div class="hotspot-inp-box" v-if="toolAct == 3">
      <div class="hotspot-view">
        标题
        <input type="text" v-model="title"/>
      </div>
      <!-- <div class="hotspot-view" v-if="selectValue == 3">
        选择视频
        <div class="hotspot-icon">
          <div class="hotspot-icon-act" @click="ShowIcon">
            <img :src="actionsVideo" alt="">
          </div>
          <div class="iconlist" v-show="isShowIcon">
            <div v-for="icon in videoList" :class="actionsVideo == icon.coverUrl ? 'icon-box act' : 'icon-box'" :key="icon.id"
              @click="selectVideo(icon)">
              <img :src="icon.coverUrl" alt="">
            </div>
          </div>
        </div>
      </div> -->
      <div class="hotspot-view">
        视频图标
        <div class="hotspot-icon">
          <div class="hotspot-icon-act" @click="ShowIcon">
            <img :src="actions" alt="">
          </div>
          <div class="iconlist" v-show="isShowIcon">
            <div v-for="(icon, index) in iconList" :class="actions == icon ? 'icon-box act' : 'icon-box'" :key="index"
                 @click="selectIcon(icon.filePath)">
              <img :src="icon.filePath" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="hotspot-view">
        图标大小(缩放比例)
        <el-slider v-model="scale" style="width: 100%;" @change="scaleChange"></el-slider>
        <!-- <div class="img-size"><img id="imgSize" :src="actions" :style="imgStyle"></div> -->
        <div class="img-size" id="imgHtml"></div>
      </div>
      <div class="hotspot-view">
        视频列表
        <div class="select">
          <div :class="videourl == video.url ? 'select-box selAct' : 'select-box'" v-for="(video, index) in videoList"
               :key="index" @click="selectVideo(video)">
            <img :src="video.coverUrl" style="margin-right: 4px;">{{ video.title }}
          </div>
        </div>
      </div>
      <div>
        <button class="hotspot-but-s" @click="clickConfirm">完成设置</button>
        <button class="hotspot-but-c" @click="clickCancel">取消设置</button>
      </div>
    </div>
    <!-- 背景音乐 -->

    <div class="hotspot-inp-box" v-if="toolAct == 2">
      <!-- <div class="hotspot-view">
        标题
        <input type="text" v-model="title" />
      </div> -->
      <!-- <div class="hotspot-view" v-if="selectValue == 3">
        选择视频
        <div class="hotspot-icon">
          <div class="hotspot-icon-act" @click="ShowIcon">
            <img :src="actionsVideo" alt="">
          </div>
          <div class="iconlist" v-show="isShowIcon">
            <div v-for="icon in videoList" :class="actionsVideo == icon.coverUrl ? 'icon-box act' : 'icon-box'" :key="icon.id"
              @click="selectVideo(icon)">
              <img :src="icon.coverUrl" alt="">
            </div>
          </div>
        </div>
      </div> -->
      <div class="hotspot-view">
        音乐列表
        <div class="select">
          <div v-for="(item, index) in audioList" :key="index"
               :class="audioUrlAct == item.url ? 'select-box selAct' : 'select-box'" @click="selectAudio(item)">
            <!-- <img :src="video.coverUrl"> -->
            <img src="/static/main/audio.png" class="section-img"/>{{ item.title }}
          </div>
        </div>
      </div>
      <div class="hotspot-view">
        应用区域:
        <select name="" id="" v-model="senceValue" @change="changeSence">
          <option value="1">当前场景</option>
          <option value="2">全部场景</option>
        </select>
      </div>
      <div>
        <button class="hotspot-but-s" @click="clickConfirmAudio">完成设置</button>
        <button class="hotspot-but-c" @click="clickCancel">取消设置</button>
      </div>
    </div>
    <div :class="errorMsg ? 'mssage act' : 'mssage'" v-show="errorMsg">{{ errorMsg }}</div>
  </div>
</template>

<script>
import {tblMediaAssetsId, addTblHotspot, tblHotspotById, tblIconTemplate} from "../../src/api/api.js";

export default {
  name: "AddHotspot",
  model: {
    prop: "isAddHotspotShow",
    event: "update:isAddHotspotShow",
  },
  props: {
    hotspotInfo: {
      required: true,
    },
    isAddHotspotShow: {
      type: Boolean,
      required: true,
    },
    panoInfo: {
      required: true,
    },
    toolAct: {
      required: true,
    },
    krpano: {
      required: true,
    },
    sceneList: {
      required: true,
    },
    currentSceneId: {
      required: true,
    },
    iseditorShow: {
      required: true,
    },
    clickMouseLocation: {
      required: true,
    },
    content:{//编辑器内容
      required: true,
    },
  },
  // emits: ["addHotSpot"],
  data() {
    return {
      imgStyle: '',
      audioUrlAct: '',
      isShowIcon: false,
      scale: 100,
      senceValue: 1,
      actions: '',//当前图标类型
      // iconList: ['static/main/hot-route.png', 'static/main/hot-right.png', 'static/main/hot-left.png'],
      iconList: [],
      peak_tooltip: "",
      errorMsg: '',
      imageUrl: "",
      selectValue: "2",//热点类型
      selectSceneId: 0,
      title: "",//标题
      tooltip: "",//提示
      distorted: true,//是否扭曲
      videourl: '',//视频地址
      posterurl: "",//视频封面
      loop: true,//是否循环
      pausedonstart: true,//是否暂停
      style: '',
      videoList: [],
      // 跳转热点模板
      toGoTemplate: {
        scale: 1,
        edge: "center",
        oy: "-20",
        distorted: false,
        url: "static/skin/hotspot/portal.png",

        // 自定义部分
        // id: "2",
        // name: "peak_hotspot_",
        ath: "-155",
        atv: "2",
        peak_type: "3",
        peak_sceneId: "2", // 场景图的id
        peak_to_scene: "scene_1",
        peak_to_sceneId: "1", // 要跳转的场景图id
        peak_tooltip: "前往篮球场",
      },

      // 普通标记热点模板
      markerTemplate: {
        scale: 1,
        edge: "center",
        oy: "-20",
        url: "static/skin/hotspot/line.png",

        ath: "-83",
        atv: "-11",
        id: "8",
        name: "peak_hotspot_8",
        peak_type: "2",
        peak_sceneId: "2",
        peak_head:
            "https://resource.v123.cn/v/Data/upload/live/auth/656/image/5c38805344125.jpg",
        peak_tooltip: "不知名的神秘大楼",
      },
      videoHttp: 'https://qjlc.dawangdawang.cn/',
      audioList: [],
      imgWidth: 0,
      imgHeight: 0,
      // iconHttp: 'http://192.168.0.122:8889',
      iconHttp: '',
      isedit: false,
      hotspotName: '',
    };
  },
  watch: {
    sceneList: {
      handler(newVal) {
        // console.log("newVal", newVal);
      },
    },
    clickMouseLocation: {
      handler(newVal) {
        // console.log("clickMouseLocation", newVal);
      },
    },
    isAddHotspotShow: {
      handler(newVal) {
        console.log(newVal, '是否显示')
        if (newVal) {
          if (this.toolAct == 3) {
            this.selectValue = 1//视频类型
          }
          if (this.hotspotInfo) {
            console.log(this.hotspotInfo)
          }
        }
      },
    },
    panoInfo: {
      handler(newVal) {
        // console.log("panoInfo", newVal);
      },
    },
    toolAct: {
      handler(newVal) {
        console.log("toolAct", newVal);
        this.title = ''
        this.tooltip = ''
        if (newVal == 3) {
          this.getIconList()
          this.selectValue = 1
          this.getVideoList()
        } else if (newVal == 1) {
          this.getIconList()
        } else if (newVal == 2) {
          this.getAudioList()
        }

      },
    },
    hotspotInfo(newVal, oloVal) {
      console.log("hotspotInfo", newVal);
      console.log("hotspotInfooloVal", oloVal);
      if(newVal.title){

        this.title = newVal.title
        this.scale = newVal.scale * 100
        this.actions = newVal.url
        this.videourl = newVal.videourl
        this.selectValue = newVal.peak_type
        this.loop = newVal.loop
        this.pausedonstart = newVal.pausedonstart
        this.selectSceneId = newVal.peak_to_sceneId
        this.isedit = true//有信息，是编辑热点
        this.hotspotName = newVal.name
        this.imgView()
        //图标大小
        let that = this
        setTimeout(function () {
          that.scaleChange(newVal.scale * 100)
        }, 2500)

      }
    }
  },
  methods: {
//热点详情中是否显示富文本编辑器
    changeEditor(){
      if(this.iseditorShow){//要关闭
        this.$emit('editorShow', false)
      }else{
        this.$emit('editorShow', true)
      }
    },
    //刷新全部数据
    resAll() {
      this.selectValue = 2//热点类型
      this.senceValue = 1//音乐应用区域
      this.selectSceneId = 0//场景id
      this.scale = 100//缩放
      this.isShowIcon = false//是否显示图标
      this.title = ''//标题
      this.tooltip = ''//提示
      this.distorted = true//是否扭曲
      this.loop = true//是否循环
      this.pausedonstart = true//是否暂停
      this.imgHeight = 0
      this.imgWidth = 0
      this.isedit = false
      if (this.toolAct == 3) {
        this.videourl = ''//视频地址
        this.posterurl = ''//视频封面
        this.imgView()
      } else if (this.toolAct == 1) {
        this.actions = this.iconList[0].filePath //当前图标
        this.imgView()
      } else if (this.toolAct == 2) {
        this.audioUrlAct = this.audioList[0].url//音乐地址
      }
    },
    //音频区域选择
    changeSence(e) {
      this.senceValue = e.target.value
      if (this.senceValue == 1) {

      }
    },
    //选择音频
    selectAudio(e) {
      this.audioUrlAct = e.url
    },
    //滑动图标大小
    scaleChange(e) {
      this.scale = e
      if (this.imgHeight == 0) {
        let image = document.querySelector('#imgSize');
        this.imgHeight = image.offsetHeight
        this.imgWidth = image.offsetWidth
      }
      document.getElementById('imgSize').style.width = this.imgWidth * e / 100 + 'px'
      document.getElementById('imgSize').style.height = this.imgHeight * e / 100 + 'px'
      // this.imgStyle = 'width:' + this.imgWidth * e / 100 + 'px;height:' + this.imgHeight * e / 100 + 'px'
    },
    //获取图标列表
    getIconList() {
      tblIconTemplate({current: 1,size: 1000}, this.panoInfo.access_token).then((res) => {
        // console.log(res.data);
        res.data.records.forEach((item) => {
          item.filePath = this.iconHttp + item.filePath
        })
        this.iconList = res.data.records
        this.actions = res.data.records[0].filePath
        this.imgView()
      }).catch((err) => {

      })
    },
    //修改尺寸图标显示
    imgView() {
      console.log(this.actions)
      setTimeout(() => {
        let imghtml = '<img id="imgSize" src="' + this.actions + '"  draggable="true" >'
        document.getElementById('imgHtml').innerHTML = imghtml
      },500)
    },
    //
    selectVideo(e) {
      this.videourl = e.url
      this.posterurl = e.coverUrl
    },
    //获取音频频列表
    getAudioList() {
      tblMediaAssetsId({groupId: this.panoInfo.groupId, type: 4}, this.panoInfo.access_token).then((res) => {
        this.audioList = res.data.records
        this.audioUrlAct = res.data.records[0].url
      }).catch((err) => {

      })
    },
    //获取视频列表
    getVideoList() {
      tblMediaAssetsId({groupId: this.panoInfo.groupId, type: 3}, this.panoInfo.access_token).then((res) => {
        // console.log(res.data.records);
        res.data.records.forEach((item) => {
          item.url = item.url
          item.coverUrl = item.coverUrl
          // item.url = this.videoHttp + item.url
          // item.coverUrl = this.videoHttp + item.coverUrl
        })
        this.videoList = res.data.records
        // this.videourl = this.videoList[0].url
        // this.posterurl = this.videoList[0].coverUrl
      }).catch((err) => {

      })
    },
    //类型选择
    changeType(e) {
      console.log("e", e.target.value);
      this.selectValue = e.target.value

      if (e.target.value == 5) {
        this.$emit('editorShow', true)
      } else {

        this.$emit('editorShow', false)
      }
    },
    //点击显示图标选择
    ShowIcon() {
      this.isShowIcon = !this.isShowIcon
    },
    // 选择图标
    selectIcon(e) {
      this.actions = e
      this.imgStyle = ''
      this.isShowIcon = !this.isShowIcon
      this.scale = 100
      this.imgHeight = 0
      this.imgWidth = 0
      this.imgView()
    },
    // 选择场景
    selectScene(e) {
      // console.log(e)
      this.selectSceneId = e
    },
    //错误信息提示
    changeMsg(e) {
      this.errorMsg = e
      let clears
      clears = setTimeout(() => {
        this.errorMsg = ''
        clearTimeout(clears)
      }, 3000)
    },
    clickCancel() {
      this.$emit("update:isAddHotspotShow", false);
      this.$emit('delHotSpot')
      this.resAll()
    },
    clickConfirmAudio() {

      if (this.audioUrlAct == '') {
        this.changeMsg("请先上传音乐")
        return
      }
      let data = {
        audioUrl: this.audioUrlAct,
        type: this.senceValue,
      }
      this.$emit("setAudio", data);
      this.$emit("update:isAddHotspotShow", false);

      //刷新数据
      this.resAll()
    },
    clickConfirm() {
      let currentSceneName = this.krpano.get("xml.scene"); // 当前场景名
      let currentScene = this.krpano.get("scene").getItem(currentSceneName); // 当前场景
      let currentSceneId = currentScene.index; // 当前场景id
      let {ath, atv} = this.clickMouseLocation; // 鼠标点击球形坐标
      if (this.hotspotInfo.ath) {
        ath = this.hotspotInfo.ath
        atv = this.hotspotInfo.atv
        this.peak_tooltip = this.hotspotInfo.peak_tooltip
        this.style = this.hotspotInfo.style
      }
      let peak_to_scene = ''
      this.sceneList.forEach(el => {
        if (el.index == this.selectSceneId) {
          peak_to_scene = el.name
        }
      });
      let id = Date.now(); // 热点id
      let name = ''
      if (!this.hotspotName) {
        name = `peak_hotspot_${id}`; // 热点名称
      } else {
        name = this.hotspotName
      }

      let hotspotInfo = {};

      if (this.title == '') {
        this.changeMsg('请输入标题');
        return;
      }
      console.log(this.title)
      // console.log(this.toolAct)
      if (this.selectValue == 2 && this.toolAct == 1) {
        hotspotInfo = {
          ...this.markerTemplate,
          ath,//水平位置
          atv,//垂直位置
          id,
          name,//热点名称
          distorted: false,
          scale: this.scale / 100,
          edge: "center",//热点边缘
          title: this.title,
          // type: "image",
          url: this.actions,
          style: this.style ? this.style : "skin_hotspotstyle",//热点类型
          peak_type: this.selectValue,//热点类型
          peak_sceneId: currentSceneId,//热点所属场景
          peak_tooltip: this.peak_tooltip,
          peak_to_sceneId: '',
          peak_to_scene: peak_to_scene,
          onclick: "looktohotspot(get(name),100);",
        }
      } else if (this.selectValue == 3 && this.toolAct == 1) {
        if (this.selectSceneId != 0 && this.selectSceneId == '') {
          this.changeMsg('请选择跳转场景');
          return;
        }
        // this.imageUrl = this.actions
        hotspotInfo = {
          ...this.toGoTemplate,
          ath,
          atv,
          id,
          name,
          title: this.title,
          scale: this.scale / 100,
          type: "route",
          url: this.actions,
          style: this.style ? this.style : 'skin_hotspotstyle',
          peak_type: this.selectValue,
          peak_sceneId: currentSceneId,
          peak_tooltip: this.peak_tooltip,
          peak_to_sceneId: this.selectSceneId,
          // onclick: `looktohotspot(get(${name}),100);`,
          peak_to_scene: peak_to_scene,
          οnclick: "togglepause();",
          onloaded: "addHotspotImage();",
        }
      } else if (this.selectValue == 4 && this.toolAct == 1) {//普通标记
        // this.imageUrl = this.actions
        hotspotInfo = {
          ...this.toGoTemplate,
          ath,
          atv,
          id,
          name,
          title: this.title,
          scale: this.scale / 100,
          type: "route",
          url: this.actions,
          style: this.style ? this.style : 'skin_hotspotstyle',
          peak_type: this.selectValue,
          peak_sceneId: currentSceneId,
          peak_tooltip: this.peak_tooltip,
          peak_to_sceneId: this.selectSceneId,
          // onclick: `looktohotspot(get(${name}),100);`,
          peak_to_scene: peak_to_scene,
          οnclick: "",
          onloaded: "addHotspotImage();",
        }
      } else if (this.selectValue == 5 && this.toolAct == 1) {//弹窗标记
        // this.imageUrl = this.actions
        // console.log(this.content,'热点富文本内容')
        if(this.content==''){
          this.changeMsg('富文本内容不能为空');
          return;
        }

        this.$emit('editorShow', false)
        hotspotInfo = {
          ...this.toGoTemplate,
          ath,
          atv,
          id,
          name,
          title: this.title,
          scale: this.scale / 100,
          type: "route",
          url: this.actions,
          style: this.style ? this.style : 'skin_hotspotstyle',
          peak_type: this.selectValue,
          peak_sceneId: currentSceneId,
          peak_tooltip: this.peak_tooltip,
          peak_to_sceneId: this.selectSceneId,
          onclick: `looktohotspot(get(${name}),100);`,
          peak_to_scene: peak_to_scene,
          editorhtml:this.content,
          // οnclick: "",
          onloaded: "addHotspotImage();",
        }
      } else if (this.selectValue == 1 && this.toolAct == 3) {
        if (this.videourl == '') {
          this.changeMsg('请选择视频');
          return;
        }
        hotspotInfo = {
          ...this.toGoTemplate,
          ath,
          atv,
          id,
          name,
          title: this.title,
          edge: "center",
          scale: this.scale / 100,
          url: this.actions,
          style: this.style ? this.style : "peak_hotspotstyle_tooltip",//热点类型
          videourl: this.videourl,
          // posterurl: this.posterurl,
          οnclick: "togglepause();",
          distorted: false,
          // type: "image",
          loop: this.loop,
          pausedonstart: this.pausedonstart,
          peak_type: this.selectValue,
          peak_sceneId: currentSceneId,
          peak_tooltip: this.peak_tooltip,
          peak_to_sceneId: '',
          peak_to_scene: peak_to_scene,
        }
      }
      if (!this.isedit) {
        this.$emit("update:isAddHotspotShow", false);
        this.$emit("addHotSpot", hotspotInfo);
      } else {
        this.$emit("update:isAddHotspotShow", false);
        this.$emit("edit", hotspotInfo);
      }
      //刷新数据
      this.resAll()
      //  清除父组件热点数据
      this.$emit('delHotSpot')
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.add-hotspot-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;

  .hotspot-inp-box {
    width: 100%;
  }
}

.select {
  width: auto;
  display: block;
  max-height: 130px;
  overflow: auto;
}

.select-box {
  width: 100%;
  height: auto;
  overflow: hidden;
  float: left;
  box-sizing: border-box;
  margin-bottom: 10px;
  display: flex;
  justify-content: left;
  align-items: center;
  box-sizing: border-box;
  border: 2px solid #363636;
}

.selAct {
  border: 2px solid #2E5CF6;
  background: #2E5CF6;
  border-radius: 5px;
  overflow: hidden;
  box-sizing: border-box;
}

.select-box img {
  border-radius: 5px;
  overflow: hidden;
  width: 30px;
  height: 30px;
}

.select-title {
  width: 100%;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
}

.mssage {
  position: fixed;
  top: -200px;
  left: 50%;
  width: 200px;
  height: auto;
  margin-left: -100px;
  padding: 10px;
  border-radius: 5px;
  background: #4D4D4D;
  z-index: 9999;
  text-align: center;
}

.mssage.act {
  opacity: 1;
  top: 100px;
  animation: myfirst 3s;
  -webkit-animation: myfirst 3s;
  /* Safari and Chrome */
}

@keyframes myfirst {
  0% {
    top: -200px;
  }

  25% {
    top: 100px;
  }

  50% {
    top: 100px;
  }

  75% {
    top: 100px;
  }

  100% {
    top: -200px;
  }
}

@-webkit-keyframes myfirst

  /* Safari 与 Chrome */
{
  0% {
    top: -200px;
  }

  25% {
    top: 100px;
  }

  50% {
    top: 100px;
  }

  75% {
    top: 100px;
  }

  100% {
    top: -200px;
  }
}

.hotspot-view {
  width: 100%;
  display: flex;
  padding: 10px;
  background: #363636;
  flex-direction: column;
  line-height: 30px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.hotspot-view input,
.hotspot-view select {
  width: 100%;
  height: 30px;
  line-height: 30px;
  border: none;
  background: #4D4D4D;
  border-radius: 4px;
  color: #ffffff;
  border: none;
  padding: 0 10px;
}

.hotspot-but-s {
  width: 100%;
  height: 30px;
  background: #2E5CF6;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  margin-bottom: 10px;
}

.hotspot-but-c {
  width: 100%;
  height: 30px;
  background: #363636;
  color: #ffffff;
  border: none;
  border-radius: 4px;
}

.hotspot-icon {
  width: 100%;
  height: auto;
  position: relative;
}

.hotspot-icon-act {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1A1A1A;
  border-radius: 4px;
}

.hotspot-icon-act img {
  width: 40px;
  height: 40px;
}

.iconlist {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  top: 44px;
  left: 0;
  z-index: 99999;
  background: #1A1A1A;
}

.icon-box {
  width: 33%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1A1A1A;
}

.icon-box img {
  width: 30px;
  height: 30px;
  margin: 5px 0;
}

.icon-box.act {
  background: #2E5CF6;
}

.el-slider__bar {
  background: #2E5CF6 !important;
}

.select-box img.section-img {
  width: 24px;
  height: 20px;
  margin-right: 6px;
}

.img-size {
  width: 137px;
  height: 100px;
  overflow: auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.img-size img {
  height: auto;
  width: auto;
}

/* 修改滚动条的宽度 */
::-webkit-scrollbar {
  width: 8px;
  /* 纵向滚动条的宽度 */
  height: 8px;
  /* 横向滚动条的高度 */
  background: #363636;
}

/* 滚动条轨道部分 */
::-webkit-scrollbar-track {
  background-color: #4D4D4D;
  border-radius: 10px;
}

/* 滚动条滑块部分 */
::-webkit-scrollbar-thumb {
  background-color: #666;
  border-radius: 10px;
}

/* 鼠标悬停在滑块上时 */
::-webkit-scrollbar-thumb:hover {
  background-color: #888888;
}

::-webkit-scrollbar-corner {

  background: #363636;
}
</style>
